module.exports = __webpack_public_path__ + "static/media/mh.70c23511.svg";